import type { DocumentAttachment } from '@getaccept/lib-shared/src/types/document-attachment';
import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { DocumentAttachmentMutations } from '../graphql/document-attachment.mutations';
import type { CreateDocumentAttachmentDTO } from '../dtos/create-document-attachment-dto';
import { DocumentAttachmentQueries } from '../graphql/document-attachment.queries';

export class DocumentAttachmentService {
  static async update(
    id: string,
    requireView: boolean,
    accessRecipientList: string[]
  ): Promise<boolean> {
    const { data } = await apolloClientInternal.mutate({
      mutation: DocumentAttachmentMutations.update,
      variables: {
        id,
        requireView,
        accessRecipientList,
      },
    });
    return !!data;
  }

  static async create(payload: CreateDocumentAttachmentDTO): Promise<DocumentAttachment> {
    const {
      data: { addDocumentAttachment },
      errors,
    } = await apolloClientInternal.mutate({
      mutation: DocumentAttachmentMutations.create,
      variables: { ...payload },
    });
    if (errors?.length) {
      throw errors[0];
    }
    return addDocumentAttachment;
  }

  static async delete(documentAttachmentId: string): Promise<boolean> {
    const { data } = await apolloClientInternal.mutate({
      mutation: DocumentAttachmentMutations.delete,
      variables: {
        id: documentAttachmentId,
      },
    });
    return data;
  }

  static async load(documentId: string): Promise<DocumentAttachment[]> {
    const {
      data: { document },
    } = await apolloClientInternal.query({
      query: DocumentAttachmentQueries.load,
      variables: { documentId },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return document.documentAttachments;
  }
}
